module.exports = __webpack_public_path__ + "img/s1White.01010cf6.png";